import { downloadInfo } from '@/mocks/home';

export default function DownloadSection() {
  return (
    <section id="download" className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20with%20soft%20evening%20light%2C%20comfortable%20sofa%20with%20blanket%2C%20smartphone%20on%20coffee%20table%2C%20warm%20ambient%20lighting%20from%20table%20lamp%2C%20relaxed%20atmosphere%2C%20modern%20interior%20design%2C%20cinematic%20mood&width=1920&height=1080&seq=download-bg&orientation=landscape"
          alt="APP下载"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>

      <div className="relative z-10 max-w-[800px] mx-auto px-4 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-black text-white mb-4 tracking-wider">
          {downloadInfo.title}
        </h2>
        <p className="text-white/70 text-lg md:text-xl mb-3 font-heading">
          {downloadInfo.subtitle}
        </p>
        <p className="text-white/50 text-sm md:text-base max-w-[550px] mx-auto mb-10 leading-relaxed">
          {downloadInfo.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={downloadInfo.iosLink}
            className="whitespace-nowrap px-8 py-4 bg-foreground-900 text-white rounded-full text-base font-semibold hover:bg-foreground-800 transition-all duration-200 inline-flex items-center gap-3 cursor-pointer group"
          >
            <span className="w-9 h-9 bg-accent-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
              <i className="ri-apple-fill text-white text-lg"></i>
            </span>
            iOS 版下载
            <i className="ri-arrow-right-up-line text-white/60 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
          <a
            href={downloadInfo.androidLink}
            className="whitespace-nowrap px-8 py-4 border-2 border-white/30 text-white rounded-full text-base font-semibold hover:bg-white/10 transition-all duration-200 inline-flex items-center gap-3 cursor-pointer group"
          >
            <span className="w-9 h-9 bg-white/20 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
              <i className="ri-android-fill text-white text-lg"></i>
            </span>
            Android 版下载
            <i className="ri-arrow-right-up-line text-white/60 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 text-white/40 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-accent-400 text-lg"></i>
            <span>安全无毒</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-speed-up-line text-accent-400 text-lg"></i>
            <span>极速下载</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-device-line text-accent-400 text-lg"></i>
            <span>全平台支持</span>
          </div>
        </div>
      </div>
    </section>
  );
}